import Phaser from 'phaser';

/** Generate textures used by the particle/effects systems */
export function generateEffectTextures(scene: Phaser.Scene): void {
  generateFogParticle(scene);
  generateGlowDot(scene);
}

function generateFogParticle(scene: Phaser.Scene): void {
  const key = 'fog-particle';
  if (scene.textures.exists(key)) return;

  const size = 32;
  const canvas = scene.textures.createCanvas(key, size, size)!;
  const ctx = canvas.context;

  // Soft radial gradient circle
  const gradient = ctx.createRadialGradient(
    size / 2, size / 2, 0,
    size / 2, size / 2, size / 2
  );
  gradient.addColorStop(0, 'rgba(200, 200, 220, 0.6)');
  gradient.addColorStop(0.5, 'rgba(200, 200, 220, 0.2)');
  gradient.addColorStop(1, 'rgba(200, 200, 220, 0)');

  ctx.fillStyle = gradient;
  ctx.fillRect(0, 0, size, size);

  canvas.refresh();
}

function generateGlowDot(scene: Phaser.Scene): void {
  const key = 'glow-dot';
  if (scene.textures.exists(key)) return;

  const size = 16;
  const canvas = scene.textures.createCanvas(key, size, size)!;
  const ctx = canvas.context;

  const gradient = ctx.createRadialGradient(
    size / 2, size / 2, 0,
    size / 2, size / 2, size / 2
  );
  gradient.addColorStop(0, 'rgba(255, 255, 255, 1)');
  gradient.addColorStop(0.3, 'rgba(255, 255, 255, 0.5)');
  gradient.addColorStop(1, 'rgba(255, 255, 255, 0)');

  ctx.fillStyle = gradient;
  ctx.fillRect(0, 0, size, size);

  canvas.refresh();
}
